import type { AnyObject } from "@entrilia/shared/types.ts";
import { isShowSerieLabel } from "../style/serie/isShowSerieLabel.ts";
import { isShowSerieLabelConnector } from "../style/serie/isShowSerieLabelConnector.ts";
import type { ChartStyleSettings, PivotRowValueCell } from "../../../../../../../../api/types/svTypes.ts";

export function getBasicSerieLabel(name: string | undefined, settingsArea: ChartStyleSettings, data: AnyObject[]) {
  return {
    visible: isShowSerieLabel(name, settingsArea),
    customizeText: (info: { seriesName: string; value: number | undefined }) => {
      const row = data.find((r) => {
        const cell = r[info.seriesName] as PivotRowValueCell;
        return cell?.value === info.value;
      });
      if (row !== undefined) {
        const cell = row[info.seriesName] as PivotRowValueCell;
        return cell?.formattedValue;
      }
      return info.value;
    },
    connector: {
      visible: isShowSerieLabelConnector(name, settingsArea),
    },
    font: { family: "Roboto" },
  };
}
